import { get, post, put, destroy } from "./base";

const CartServ = {
    getCart: (lat, lng) => get(`/cart?lat=${lat || ''}&lng=${lng || ''}`),
    addToCart: (productId, quantity = 1, selectedOptions = {}, lat, lng) => post("/cart", { productId, quantity, selectedOptions, lat, lng }),
    updateQuantity: (itemId, quantity, lat, lng) => put("/cart", { itemId, quantity, lat, lng }),
    removeFromCart: (itemId, lat, lng) => destroy(`/cart/${itemId}?lat=${lat || ''}&lng=${lng || ''}`), // Using query params for delete as body might not be supported/standard
    clearCart: () => destroy("/cart"),
    syncCart: (items, lat, lng) => post("/cart/sync", { items, lat, lng }),
    mergeCart: (items, lat, lng) => post("/cart/merge", { items, lat, lng }),
};

export default CartServ;
